export const themeProps = {
  alignItems: String,
  alignSelf: String,
  background: String,
  backgroundAttachment: String,
  backgroundColor: String,
  backgroundImage: String,
  backgroundPosition: String,
  backgroundRepeat: String,
  backgroundSize: String,
  border: String,
  borderColor: String,
  borderBottom: String,
  borderLeft: String,
  borderTop: String,
  borderRight: String,
  borderRadius: String,
  bottom: String,
  boxShadow: String,
  boxSizing: String,
  color: String,
  cursor: String,
  display: String,
  filter: String,
  flexDirection: String,
  flexWrap: String,
  flex: String,
  smallTabletFontSize: String,
  mobileFontSize: String,
  fontFamily: String,
  fontSize: String,
  fontWeight: String,
  fontStyle: String,
  height: String,
  hoverBrightness: String,
  hoverBackgroundColor: String,
  hoverBackgroundSize: String,
  hoverBorderRadius: String,
  hoverColor: String,
  justifyContent: String,
  left: String,
  lineHeight: String,
  margin: String,
  marginTop: String,
  marginBottom: String,
  marginLeft: String,
  marginRight: String,
  maxHeight: String,
  maxWidth: String,
  minHeight: String,
  minWidth: String,
  padding: String,
  position: String,
  opacity: String,
  order: String,
  overflow: String,
  overflowX: String,
  overflowY: String,
  right: String,
  textAlign: String,
  textDecoration: String,
  top: String,
  width: String,
  whiteSpace: String,
  zIndex: String,
  transformation: String
};
